import { render, staticRenderFns } from "./Sala.vue?vue&type=template&id=22f2f2a2&scoped=true"
import script from "./Sala.vue?vue&type=script&lang=js"
export * from "./Sala.vue?vue&type=script&lang=js"
import style0 from "./Sala.vue?vue&type=style&index=0&id=22f2f2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f2f2a2",
  null
  
)

export default component.exports